import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {
  MatNavList,
  MatListItem,
  MatListItemAvatar,
  MatListItemTitle,
  MatListItemLine,
  MatListItemMeta,
  MatDivider,
} from '@angular/material/list';
import { CoreSelectors } from '@next/core-lib';
import { RootState } from '@next/core-lib/app';
import { PageToolbarComponent } from '@next/core-lib/components';
import { DialogService, DIALOG_RETURN_TYPES } from '@next/core-lib/dialog';
import { LocaleService, TranslatePipe, AgrNumberPipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Barn } from '../../models/settings.model';
import * as settingActions from '../../store/actions/settings.actions';
import { getBarns } from '../../store/selectors/settings.selectors';
import { BarnItemDialogComponent } from '../barn-item-dialog/barn-item-dialog.component';

@Component({
  selector: 'app-barn-overview',
  templateUrl: 'barn-overview.component.html',
  imports: [
    PageToolbarComponent,
    NgIf,
    MatNavList,
    NgFor,
    MatListItem,
    MatIcon,
    MatListItemAvatar,
    MatListItemTitle,
    MatListItemLine,
    MatListItemMeta,
    MatIconButton,
    MatDivider,
    AsyncPipe,
    TranslatePipe,
    AgrNumberPipe,
  ],
})
export class BarnOverviewComponent {
  barns$ = this.store.select(getBarns);
  isLoading$: Observable<boolean> = this.store.select(CoreSelectors.selectLoading);

  constructor(
    private readonly store: Store<RootState>,
    private readonly dialog: DialogService,
    private readonly locale: LocaleService,
  ) {}

  addDialog() {
    this.dialog
      .form(BarnItemDialogComponent, {
        confirmButton: true,
        confirmButtonText: this.locale.translate('save'),
        pushHistoryState: false,
        barnId: null,
      })
      .subscribe((result) => {
        if (result.status === DIALOG_RETURN_TYPES.confirm) {
          this.store.dispatch(settingActions.upsertBarnRequest({ barn: result.result.barn }));
        }
      });
  }

  openBarnEdit(barnId: number) {
    this.store.dispatch(
      settingActions.setSelectedBarn({
        barnId,
      }),
    );
    this.dialog
      .form(BarnItemDialogComponent, {
        confirmButton: true,
        confirmButtonText: this.locale.translate('save'),
        pushHistoryState: false,
        barnId,
      })
      .subscribe((result) => {
        if (result.status === DIALOG_RETURN_TYPES.confirm) {
          this.store.dispatch(settingActions.upsertBarnRequest({ barn: result.result.barn }));
        }
      });
  }

  delete(event: Event, barn: Barn) {
    event.preventDefault();
    event.stopImmediatePropagation();

    if (barn && barn.id) {
      this.store.dispatch(settingActions.deleteBarnWithConfirmation({ barn }));
    }
  }
}
